import { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useScrollStore } from "stores/scroll/useScrollStore";
// import useWesternDisciplines from "hooks/useWesternDisciplines";
import ChevronArrowDown from "assets/icons/chevron-arrow-down.svg?react";
import ChevronArrowRight from "assets/icons/chevron-arrow-right.svg?react";
import ProfileDefaultImage from "assets/icons/default_avater.svg";
import LogoutIcon from "assets/icons/logout.svg?react";
import Loader from "components/Spinners/Loader";
import { useAuthStore } from "stores/auth/authStore";
import { menuData } from "utils/mobilemenu";
import { useBrandDisciplineStore } from "stores/brandDiscipline/useBrandDisciplineStore";
import useWesternDisciplines from "hooks/useWesternDisciplines";

const MobileMenu = ({
  setToggle,
  signUp = () => { },
  signIn = () => { },
  signOut = () => { },
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const user = useAuthStore((state) => state.user);
  const isClientDataLoading = useAuthStore((state) => state.isLoading);
  const scrollToFirstSection = useScrollStore(
    (state) => state.scrollToFirstSection
  );
  const scrollToSecondSection = useScrollStore(
    (state) => state.scrollToSecondSection
  );
  const scrollToThirdSection = useScrollStore(
    (state) => state.scrollToThirdSection
  );
  const location = useLocation();
  const navigate = useNavigate();
  const fullName = user?.firstName + " " + user?.lastName;
  const subdomain = useAuthStore((state) => state.domain);
  const isSubdomain = Boolean(subdomain);

  const { mapDisciplineValue } = useWesternDisciplines();
  const setSelectedDiscipline = useBrandDisciplineStore(
    (action) => action.setSelectedDiscipline
  );

  const handleSelectDiscipline = (disciplineValue) => {
    const newDiscipline = mapDisciplineValue(disciplineValue);
    setSelectedDiscipline(newDiscipline ? [newDiscipline] : []);

    const searchParams = new URLSearchParams(location.search);
    searchParams.set("discipline", disciplineValue);
    const targetUrl = `/buy?${searchParams.toString()}`;

    navigate(targetUrl, { replace: true });
    setToggle(false);
    setIsOpen(false);
  };

  const handleSelectBrand = (value) => {
    if (value === "cactussaddlery") {
      navigate("/cactus");
    } else if (value === "billycook") {
      navigate("/billy-cook");
    }
    setToggle(false);
    setIsOpen(false);
  };

  const navigateToSection = (scrollToRef) => {
    if (location.pathname !== "/") {
      setToggle(false);
      navigate("/");
      setTimeout(() => {
        scrollToRef();
      }, 0);
    } else {
      setToggle(false);
      scrollToRef();
    }
  };

  return (
    <div className="flex flex-col p-4 space-y-1 bg-[rgba(43,54,75,0.80)] shadow-[-6px_21px_64px_0px_rgba(0,0,0,0.32)] backdrop-blur-[26.75px] min-h-0 overflow-y-auto">
      {user ? (
        <>
          {!isSubdomain && (isClientDataLoading ? (
            <Loader filledColor="#fff" />
          ) : (
            <NavLink
              to="/profile"
              onClick={() => setToggle(false)}
              className="flex items-center gap-[10px] py-3 text-[16px] font-medium font-montserrat leading-[19.2px] text-white hover:text-gray-300 transition-colors"
            >
              <img
                src={user?.photo ? user?.photo : ProfileDefaultImage}
                alt="profile image"
                className="profile-pic max-w-[37px] min-h-[37px] rounded-full"
              />
              {fullName}
            </NavLink>
          ))}

          {!isSubdomain && (
            <>
              <NavLink
                to="/user/horses"
                onClick={() => setToggle(false)}
                className="py-3 text-[16px] font-medium font-montserrat leading-[19.2px] text-white hover:text-gray-300 transition-colors"
              >
                My Horses
              </NavLink>
              <div className="border border-solid border-[rgba(255,255,255,0.08)]" />
            </>
          )}

          {/* My Saddles navigation item removed per user request */}

          <NavLink
            to="/my-orders"
            onClick={() => setToggle(false)}
            className="py-3 text-[16px] font-medium font-montserrat leading-[19.2px] text-white hover:text-gray-300 transition-colors"
          >
            My Orders
          </NavLink>
          <div className="border border-solid border-[rgba(255,255,255,0.08)]" />

          {!isSubdomain && (
            <div>
              <button
                onClick={() => {
                  navigate("/buy");
                  setToggle(false);
                }}
                className="flex items-center justify-between py-3 text-[16px] font-medium font-montserrat leading-[19.2px] text-white hover:text-gray-300 transition-colors w-full bg-transparent"
              >
                Buy a Saddle
                {isOpen ? (
                  <ChevronArrowDown
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsOpen(false);
                    }}
                    className="w-10 h-10"
                  />
                ) : (
                  <ChevronArrowRight
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsOpen(true);
                    }}
                    className="w-10 h-10"
                  />
                )}
              </button>

              {!isOpen && (
                <div className="border border-solid border-[rgba(255,255,255,0.08)]" />
              )}

              {isOpen && (
                <div className="pt-2">
                  {menuData.map((section) => (
                    <div key={section.title} className="space-y-4 mb-4">
                      <h2 className="text-white font-barlowCondensed text-lg font-bold leading-[110%] uppercase py-2 text-center border-y border-[rgba(255,255,255,0.24)]">
                        {section.title}
                      </h2>
                      <ul className="space-y-0">
                        {section.items.map((item, index) => (
                          <li
                            key={item.label}
                            className={`${index !== section.items.length - 1
                              ? "border-b border-[rgba(255,255,255,0.08)]"
                              : ""
                              }`}
                          >
                            <NavLink
                              onClick={(e) => {
                                e.preventDefault();
                                if (section.title === "DISCIPLINE") {
                                  handleSelectDiscipline(item.value);
                                } else if (section.title === "BRANDS") {
                                  handleSelectBrand(item.value);
                                }
                              }}
                              className="flex items-center py-3 px-4 text-white font-montserrat text-sm font-normal leading-[120%] transition-colors hover:text-gray-300"
                            >
                              <span>{item.label}</span>
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          <NavLink
            to="/event"
            onClick={() => setToggle(false)}
            className="py-3 text-[16px] font-medium font-montserrat leading-[19.2px] text-white hover:text-gray-300 transition-colors"
          >
            Schedule Now
          </NavLink>
          <div className="border border-solid border-[rgba(255,255,255,0.08)]" />

          <button
            onClick={signOut}
            className="flex items-center justify-between py-3 text-[16px] font-medium font-montserrat leading-[19.2px] text-white hover:text-gray-300 transition-colors w-full bg-transparent"
          >
            Log Out
            <LogoutIcon />
          </button>
          <div className="border border-solid border-[rgba(255,255,255,0.08)]" />
        </>
      ) : (
        // Default menu for guests (not logged in)
        <>
          {!isSubdomain && (
            <>
              <span
                onClick={() => navigateToSection(scrollToFirstSection)}
                className="py-3 text-[16px] font-medium font-montserrat leading-[19.2px] text-white hover:text-gray-300 transition-colors"
              >
                Why SaddleFit
              </span>
              <div className="border border-solid border-[rgba(255,255,255,0.08)]" />

              <span
                onClick={() => navigateToSection(scrollToSecondSection)}
                className="py-3 text-[16px] font-medium font-montserrat leading-[19.2px] text-white hover:text-gray-300 transition-colors"
              >
                How it works
              </span>
              <div className="border border-solid border-[rgba(255,255,255,0.08)]" />

              <span
                onClick={() => navigateToSection(scrollToThirdSection)}
                className="py-3 text-[16px] font-medium font-montserrat leading-[19.2px] text-white hover:text-gray-300 transition-colors"
              >
                Book Appointment
              </span>
              {!isOpen && (
                <div className="border border-solid border-[rgba(255,255,255,0.08)]" />
              )}

              <div>
                <button
                  onClick={() => {
                    navigate("/buy");
                    setToggle(false);
                  }}
                  className="flex items-center justify-between py-3 text-[16px] font-medium font-montserrat leading-[19.2px] text-white hover:text-gray-300 transition-colors w-full bg-transparent"
                >
                  Buy a Saddle
                  {isOpen ? (
                    <ChevronArrowDown
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsOpen(false);
                      }}
                      className="w-10 h-10"
                    />
                  ) : (
                    <ChevronArrowRight
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsOpen(true);
                      }}
                      className="w-10 h-10"
                    />
                  )}
                </button>
                {isOpen === false && (
                  <div className="border border-solid border-[rgba(255,255,255,0.08)]" />
                )}

                {isOpen && (
                  <div className="pt-2">
                    {menuData.map((section) => (
                      <div key={section.title} className="space-y-4 mb-4">
                        <h2 className="text-white font-barlowCondensed text-lg font-bold leading-[110%] uppercase py-2 text-center border-y border-[rgba(255,255,255,0.24)]">
                          {section.title}
                        </h2>
                        <ul className="space-y-0">
                          {section.items.map((item, index) => (
                            <li
                              key={item.label}
                              className={`${index !== section.items.length - 1
                                ? "border-b border-[rgba(255,255,255,0.08)]"
                                : ""
                                }`}
                            >
                              <NavLink
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (section.title === "DISCIPLINE") {
                                    handleSelectDiscipline(item.value);
                                  } else if (section.title === "BRANDS") {
                                    handleSelectBrand(item.value);
                                  }
                                }}
                                className="flex items-center py-3 px-4 text-white font-montserrat text-sm font-normal leading-[120%] transition-colors hover:text-gray-300"
                              >
                                <span>{item.label}</span>
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          )}

          <NavLink
            to="/event"
            onClick={() => setToggle(false)}
            className="py-3 text-[16px] font-medium font-montserrat leading-[19.2px] text-white hover:text-gray-300 transition-colors"
          >
            Schedule Now
          </NavLink>
          <div className="border border-solid border-[rgba(255,255,255,0.08)] block sm:hidden" />

          <div className="flex flex-col gap-y-4 py-4 sm:hidden">
            <button
              onClick={signIn}
              className="w-full px-6 py-4 bg-[#F7F7F6] text-[#1f2937] rounded-[150px] hover:bg-gray-100 transition-colors text-[18px] font-medium font-montserrat leading-[21.6px]"
            >
              Sign In
            </button>
            <button
              onClick={signUp}
              className="w-full px-6 py-4 border border-white bg-transparent text-white rounded-[150px] hover:bg-white/10 transition-colors text-[18px] font-medium font-montserrat leading-[21.6px]"
            >
              Join Now
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default MobileMenu;
